<template>
    <el-popover
        v-if="columns"
        placement="bottom"
        width="200"
        popper-class="data-grid-toolbar-popper"
        trigger="click"
        v-model="visible">
        <el-checkbox-group v-model="value" v-if="columns" @change="onChange">
            <el-checkbox v-for="column in showColumns" :key="column.label" :label="column.label"></el-checkbox>
        </el-checkbox-group>
    <item slot="reference"  :icon="icon" name="列设置"/>
  </el-popover>
</template>

<script>
import icon from '../icons/setting.svg'
import Item from './item'
export default {
    components: {
        Item
    },
    props: {
        columns: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        showColumns () {
            return this.columns.filter(item => item.label)
        }
    },
    data () {
        return {
            value: [],
            icon,
            visible: false,
            loading: false
        }
    },
    methods: {
        onChange (value) {
            this.$emit('change', value)
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.value = this.columns.map(c => {
                if (c && c.label && !c.hidden) {
                    return c.label
                }
            })
        })
    }
}
</script>

<style lang="less">
.data-grid-toolbar-popper {
    min-width: 0px;
    .el-checkbox {
        display: block;
        margin-bottom: 6px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-button--mini {
        padding: 4px 12px!important;
    }
    .el-button+.el-button {
        margin-left: 4px!important;
    }
    .footer {
        margin-top: 10px
    }
}
</style>



// WEBPACK FOOTER //
// src/components/framework/data-grid/toolbar/columns.vue